import z from "zod";

import { zId } from "./ZId";
import { zRole } from "./ZRole";
import { zSidLabel } from "./ZSidLabel";

export const zUser = z.object({
  id: zId,
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  middleName: z.string().nullish(),
  displayId: z.number(),
  login: z.string(),
  metadataEditor: z.boolean(),
  active: z.boolean(),
  roles: zRole.array(),
  createdAt: z.string(),
  updatedAt: z.string(),
  createdBy: zSidLabel.nullish(),
  updatedBy: zSidLabel.nullish(),
});

export type ZUser = z.infer<typeof zUser>;

export type UserFilters = { text?: string };

export const zUserSaveData = zUser
  .partial()
  .pick({
    email: true,
    firstName: true,
    lastName: true,
    middleName: true,
    login: true,
    metadataEditor: true,
    active: true,
  })
  .extend({
    roles: z
      .object({
        id: zId,
      })
      .array(),
  });

export type ZUserSaveData = z.infer<typeof zUserSaveData>;
